import req from './../../../../../fetch';
import { undocumentedResponse } from './../../../../../utils';
import {
  ClaimType,
  NetworkType,
  AllAPIResponses,
  CarbonError,
} from './../../../../../index';

type Params = {
  networkType: NetworkType;
  id: number;
};
const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<ClaimType>> => {
  try {
    const resp = await req.get(
      `/api/claims/${params.networkType}/${params.id}/queue`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ClaimType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
